import request from '@/config/axios'

export interface FlipCoinReqVO {
  userResult: number
  price: number
}

export interface FlipCoinRespVO {
  gameResult: number
  reward: number
}

export const FlipCoinType = {
  FRONT: {
    name: 'HEAD',
    value: 1
  },
  BACK: {
    name: 'TAIL',
    value: 2
  }
};

/**
 * 玩翻硬币
  */
export const play = async (data: any) => {
  return await request.post({ url: `/game/flipCoin/play`, data})
}

/**
 * 查询翻硬币历史记录
  */
export const getHistoryPage = async (data: any) => {
  return await request.post({ url: `/game/history/page`, data})
}